import { render } from "./UserReport.vue?vue&type=template&id=423fcd24"
import script from "./UserReport.vue?vue&type=script&lang=js"
export * from "./UserReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__